<template>
    <svg height="17.026" viewBox="0 0 17.797 17.026" width="17.797" xmlns="http://www.w3.org/2000/svg">
        <g id="Icon_feather-edit-3" data-name="Icon feather-edit-3" transform="translate(-3.5 -3.318)">
            <path
                id="Path_2151"
                d="M18,30h7.9"
                data-name="Path 2151"
                fill="none"
                stroke="#1bc5bd"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                transform="translate(-5.601 -10.656)"
            />
            <path
                id="Path_2152"
                d="M16.348,4.863A1.862,1.862,0,0,1,18.981,7.5L8.01,18.466l-3.51.878.878-3.51Z"
                data-name="Path 2152"
                fill="none"
                stroke="#1bc5bd"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: "ActionEdit",
};
</script>
